<template>
  <el-dialog
            title="发布内容"
            :visible.sync="centerDialogVisible"
            width="50%"
            top="15vh"
            :before-close="close"
            center>
            <el-form ref="ruleForm" :rules="rules" :model="form" label-width="120px">
                <el-form-item label="类型">
                  <el-select v-model="form.type" placeholder="请选择">
                    <el-option
                      v-for="item, index in types"
                      :key="item"
                      :label="item"
                      :value="index">
                    </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="img">
                  <el-upload
                    class="upload-demo avatar-uploader"
                    action="''"
                    accept="image/*"
                    :on-change="uploadImg"
                    :limit="1"
                    :show-file-list="false">

                    <img v-if="form.img" :src="form.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
                <el-form-item label="区域" prop="location">
                    <el-input v-model="form.location"></el-input>
                </el-form-item>
                <el-form-item label="发布人" prop="public">
                    <el-input v-model="form.public"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address">
                    <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="薪资/价格" prop="fee">
                    <el-input v-model="form.fee"></el-input>
                </el-form-item>
               
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="$emit('close')">取 消</el-button>
                <el-button type="primary" @click="publishItem">发布</el-button>
                <br>
                
            </span>
            </el-dialog>
</template>
<script>
  export default {
    props: {
      centerDialogVisible: true
    },
    data() {
      return {
        form: {
          title: '',
          img: '',
          location: '',
          public: '',
          address: '',
          fee: '',
          type: 0
        },
        types: ['房屋租售', '二手转让', '车辆买卖', '招聘信息', '求职简历', '宠物', '生活服务'],
        rules: {
              title: [{
                required: true, message: '请输入标题',
                trigger: 'blur'
              }],
              img: [{
                required: true, message: '请选择图片',
                trigger: 'blur'
              }],
              location: [{
                required: true, message: '请输入区域',
                  trigger: 'blur'
              }],
              public: [{
                required: true, message: '请输入发布人',
                trigger: 'blur'
              }],
              address: [{
                required: true, message: '请输入地址',
                trigger: 'blur'
              }],
              fee: [{
                required: true, message: '请输入',
                trigger: 'blur'
              }],
          }
      }
    },
    methods: {
      publishItem() {
        const that = this
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {

            // that.$store.commit('addItem', {
            //   ...that.form
            // })
            this.$emit('close')
              
            that.$message('您的信息正在审核!');
          } else {
              // console.log('error submit!!');
          }
          });
      },
      uploadImg(file) {
        const that = this
        console.log(file)
        let reader = new FileReader();

        reader.readAsDataURL(file.raw);
　　　　　//开始转
        reader.onload = function() {
          that.form.img = reader.result;
        };
      },
      close() {
        this.$emit('close')
      }
    }
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: contain;
  }
</style>
